const normalizePath = (path = '') => path.replace(/\/+$/, '') || '/'

const getScrollBehavior = (): ScrollBehavior => (
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
)

const scrollToHashTarget = (targetElement: HTMLElement) => {
  targetElement.scrollIntoView({
    behavior: getScrollBehavior(),
    block: 'start'
  })

  const hash = `#${targetElement.id}`
  if (window.location.hash !== hash) {
    window.history.replaceState(null, '', hash)
  }
}

export default defineNuxtPlugin(() => {
  if (!process.client) return

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return
    if (event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const anchor = (event.target as Element | null)?.closest?.('a[href]')
    if (!anchor || !(anchor instanceof HTMLAnchorElement)) return
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) return
    if (anchor.closest('[data-smooth-anchor="off"]')) return

    const rawHref = anchor.getAttribute('href')
    if (!rawHref || rawHref === '#') return

    let parsedUrl: URL
    try {
      parsedUrl = new URL(rawHref, window.location.href)
    } catch {
      return
    }

    if (!parsedUrl.hash || parsedUrl.protocol === 'mailto:' || parsedUrl.protocol === 'tel:') {
      return
    }

    const targetPath = normalizePath(parsedUrl.pathname)
    const currentPath = normalizePath(window.location.pathname)

    if (parsedUrl.origin !== window.location.origin || targetPath !== currentPath) {
      return
    }

    const targetId = decodeURIComponent(parsedUrl.hash.slice(1))
    if (!targetId) return

    const targetElement = document.getElementById(targetId)
    if (!targetElement) return

    event.preventDefault()
    scrollToHashTarget(targetElement)
  })
})
